import { connect } from "react-redux";
import { moveMetric } from "actions/tool-panel/draft/actions";
import { MetricsListComponent } from "components/product-collection/product-collection-views/product-collection-grid-view/tool-panels/dimensions-tool-panel/tabs/metrics/metrics-list";
import { Metric } from "helpers/metrics/types";
import { IStore } from "reducers";

const mapStateToProps = (state: IStore): { metrics: Metric[] } => {
    return {
        metrics: state.dimensionsPanel.draft.metrics.values,
    };
};

export const MetricsListContainer = connect<
    {},
    {},
    {
        rollupAverageUnitsEnabled: boolean;
        isRollupMode: boolean;
        toggleShowOn: () => void;
    }
>(mapStateToProps, { moveMetric })(MetricsListComponent);
